import { Component, Input, isDevMode, ViewChild} from "@angular/core";
import { SlickDialogComponent } from "@slick-components";
import { IVersionReleaseModel } from "@models/version-release/version-release.model";

import { HttpService } from "@services"

@Component({
	selector: "version-release-dialog",
	templateUrl: "./version-release-dialog.component.html"
})
export class VersionReleaseDialogComponent {
	@ViewChild("dialogRef", { static: true }) dialogRef: SlickDialogComponent;
	@Input() isMobile: boolean = false;
	versionModels: IVersionReleaseModel[];

	constructor(private readonly httpService: HttpService) {
	}

	async showDialog() {
		if (this.isMobile) {
			this.dialogRef.width = 360;
		}
		else {
			this.dialogRef.width = 700;
		}

		// Release notes go live when they're saved, independent of the app version
		this.versionModels = await this.httpService.get("/versionRelease/getUnseenVersionReleases");

		if (this.versionModels.length > 0) {
			this.dialogRef.showDialog();
			// Newest first, so marking the first one covers everything shown
			await this.httpService.post(`/versionRelease/markVersionReleasesSeen?versionReleaseId=${this.versionModels[0].versionReleaseId}`, {});
		}
	}

	async showClickedVersion() {
		this.versionModels = await this.httpService.get("/versionRelease/getRecentVersionReleases", { count: 10 });
		if (this.versionModels.length > 0)
			this.dialogRef.showDialog();
	}

	close() {
		this.dialogRef.hideDialog();
	}
}
